/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Error from '../error';
import Loader from '../loader';
import NotFound from '../not-found';

const propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.bool,
  notFound: PropTypes.bool,
  children: PropTypes.node,
};

class PageStatus extends Component {
  render() {
    const { error, loading, notFound, children } = this.props;

    return error ? <Error /> : loading ? <Loader /> : notFound ? <NotFound /> : children;
  }
}

PageStatus.propTypes = propTypes;

export default PageStatus;
